import React from 'react'
import { motion } from "framer-motion";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import DescriptionIcon from '@mui/icons-material/Description';
import BoltIcon from '@mui/icons-material/Bolt';


export default function Why() {
    const features = [
        {
            icon: <AutoModeIcon sx={{ fontSize: 40 }}  />,
            title: "3-Step Digital Application Process",
        },
        {
            icon: <DescriptionIcon sx={{ fontSize: 40 }} />,
            title: "Minimal Documentation",
        },
        {
            icon: <CheckCircleIcon sx={{ fontSize: 40 }} />,
            title: "100% Online Verification Journey",
        },
        {
            icon: <AdsClickIcon sx={{ fontSize: 40 }} />,
            title: "Upfront Loan Terms & Charges",
        },
        {
            icon: <BoltIcon sx={{ fontSize: 40 }} />,
            title: "Fast Eligibility-Based Processing",
        },
    ];
    return (
        <section className="relative bg-gradient-to-r from-[#011F41] to-[#011F41] py-16 px-4 overflow-hidden">

            {/* Background Glow */}
            <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-3xl rounded-full"></div>
            <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-500/20 blur-3xl rounded-full"></div>

            <div className="max-w-7xl mx-auto relative z-10">

                {/* Heading */}
                <div className="mb-10">
                    <p className="ms-text-secondary uppercase font-semibold text-lg mb-2">
                        Why B4Salary ?
                    </p>

                    <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-snug">
                        Transparent & User-Focused Borrowing Experience
                    </h3>
                    <p className='py-2  text-gray-300 text-sm sm:text-base leading-8'>Many short-term lending platforms focus only on speed. At B4Salary, we balance convenience with transparency, responsible lending practices, and a smoother digital experience for salaried professionals.</p>
                </div>

                {/* Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">

                    {features.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className="group rounded-lg p-6 text-center
                 border border-white/60
                hover:bg-white/20 hover:scale-105 transition-all duration-300 shadow-lg"
                        >
                            <div className="flex justify-center mb-4 text-cyan-400 group-hover:text-white transition">
                                <div className='bg-white/20 p-3 rounded-lg text-white'>
                                    {item.icon}
                                </div>

                            </div>

                            <h3 className="text-white font-medium text-base">
                                {item.title}
                            </h3>
                        </motion.div>
                    ))}

                </div>
            </div>
        </section>
    )
}
